import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../contexts/AuthContext';

// Em quais peças da campanha (catálogo, pôster, stories) cada produto já está,
// pelas montagens SALVAS (GET /catalogo/campanha/:id/uso). O seletor de cada
// peça pinta a linha do que já está nela (pelo que está na tela, salvo ou não)
// e mostra ícones das outras peças.
const PECAS = [
  { chave: 'catalogo', icone: 'journal-richtext', nome: 'catálogo' },
  { chave: 'poster', icone: 'file-earmark-image', nome: 'pôster' },
  { chave: 'story', icone: 'instagram', nome: 'story' },
];

export function useUsoPecas(campanhaId) {
  const [uso, setUso] = useState({});
  useEffect(() => {
    let vivo = true;
    axios.get(`${API}/catalogo/campanha/${campanhaId}/uso`)
      .then(r => { if (vivo) setUso(Object.fromEntries(Object.entries(r.data || {}).map(([k, v]) => [k, new Set(v)]))); })
      .catch(() => { /* sem os ícones das outras peças; o resto funciona */ });
    return () => { vivo = false; };
  }, [campanhaId]);
  return uso;
}

// Linha de produto que já está nesta peça: fundo verde e barra na esquerda.
// `forte` = está no story/página aberto agora.
export const estiloLinhaUsada = (usado, forte = false) => (usado
  ? { background: forte ? '#d3ecd9' : '#ecf7ef', boxShadow: `inset 4px 0 0 ${forte ? '#146c43' : '#5cb176'}` }
  : {});

export function MarcasOutrasPecas({ uso, codpro, peca }) {
  const outras = PECAS.filter(p => p.chave !== peca && uso[p.chave]?.has(codpro));
  if (!outras.length) return null;
  return (
    <span className="text-secondary" style={{ fontSize: '0.72rem', whiteSpace: 'nowrap' }}
      title={`Já está no ${outras.map(p => p.nome).join(' e no ')} (montagem salva)`}>
      {outras.map(p => <i key={p.chave} className={`bi bi-${p.icone} ms-1`} />)}
    </span>
  );
}

export function LegendaUso({ peca }) {
  const nome = PECAS.find(p => p.chave === peca)?.nome;
  return (
    <small className="text-muted d-flex align-items-center gap-1 mb-1" style={{ fontSize: '0.68rem' }}>
      <span style={{ display: 'inline-block', width: 10, height: 10, borderRadius: 2, ...estiloLinhaUsada(true) }} />
      já está no {nome}
      <span className="ms-1">· ícones: já está em outra peça</span>
    </small>
  );
}
